export default __webpack_public_path__ + "static/media/fauna-code-quote.f35f2e57.png";